<template>
  <div>
    <div class="d-flex align-center mb-3">
      <div class="text-body-2 grey--text text--darken-1">
        "Underlying data" views open in their own browser tab with the report's filters, with their own exports and prints - the records behind the numbers,
        for manual checking and audits. Use <code v-pre>{{orderDetail(range)}}</code>, <code v-pre>{{orderLines(range)}}</code> etc. for orders and lines.
      </div>
      <v-spacer />
      <v-btn small color="primary" @click="add"><v-icon left small>mdi-plus</v-icon>Add underlying-data view</v-btn>
    </div>

    <v-card v-for="(d, i) in drilldowns" :key="d.id" outlined class="mb-3">
      <v-card-text>
        <v-row dense align="center">
          <v-col cols="12" sm="3"><v-text-field :value="d.id" outlined dense hide-details label="Id (letters/numbers)" @change="renameId(d, $event)" /></v-col>
          <v-col cols="12" sm="4"><v-text-field v-model="d.name" outlined dense hide-details label="Name (menu text)" /></v-col>
          <v-col cols="12" sm="4"><v-text-field v-model="d.description" outlined dense hide-details label="Short description" /></v-col>
          <v-col cols="auto">
            <v-btn small text color="primary" @click="edit(d, 'data')">Edit SQL</v-btn>
            <v-btn small text color="primary" @click="edit(d, 'layout')">Edit layout</v-btn>
            <v-btn small text color="primary" @click="edit(d, 'output')">Exports & prints</v-btn>
            <v-btn icon small @click="remove(i)"><v-icon small>mdi-delete-outline</v-icon></v-btn>
          </v-col>
        </v-row>
        <div class="text-caption grey--text mt-1">
          {{ d.datasets.length }} dataset(s), {{ d.ui.sections.length }} section(s), {{ (d.exports || []).length }} export(s), {{ (d.prints || []).length }} print layout(s)
        </div>
      </v-card-text>
    </v-card>
    <v-alert v-if="!drilldowns.length" type="info" dense text>No underlying-data views yet.</v-alert>
  </div>
</template>

<script>
import { state, uniqueName } from './editorState'

export default {
  name: 'RbDrilldownsTab',
  computed: { drilldowns () { return state.tpl.drilldowns } },
  methods: {
    add () {
      const id = uniqueName('records', this.drilldowns.map((d) => d.id))
      this.drilldowns.push({
        id, name: 'Records in this report', description: 'The individual records behind these numbers.',
        datasets: [{ name: 'records', sql: 'SELECT d."orderId", d."orderType", d."grandTotal"\nFROM ({{orderDetail(range)}}) d\nORDER BY d."sealedAt", d."orderId"' }],
        ui: { sections: [{ id: 's1', type: 'table', title: 'Records', width: 12, dataset: 'records', showTotals: true,
          columns: [{ field: 'orderId', label: 'Order #', link: 'order' }, { field: 'orderType', label: 'Order type' }, { field: 'grandTotal', label: 'Total', format: 'currency', align: 'right', total: 'sum' }] }] },
        exports: [{ name: 'Records', type: 'csv', dataset: 'records', details: true }, { name: 'Records', type: 'xlsx', dataset: 'records', details: true }],
        prints: []
      })
    },
    renameId (d, v) {
      const id = (v || '').replace(/[^A-Za-z0-9_-]/g, '')
      if (!id || !/^[a-z]/.test(id) || this.drilldowns.some((x) => x !== d && x.id === id)) { this.$snack('Use a unique id that starts with a lowercase letter.', 'warning'); return }
      if (state.ctx === d.id) state.ctx = id
      for (const c of state.tpl.tests.cases || []) if (c.drill === d.id) c.drill = id
      d.id = id
    },
    remove (i) {
      if (state.ctx === this.drilldowns[i].id) state.ctx = 'main'
      this.drilldowns.splice(i, 1)
    },
    edit (d, tab) {
      state.ctx = d.id
      this.$emit('goto', tab)
    }
  }
}
</script>
